import { useState, lazy, Suspense } from "react";
import { Analytics } from "@vercel/analytics/react";
import Loader from "./components/Loader";
import Landing from "./pages/Landing";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import DeferredSection from "./components/DeferredSection";

const AboutMe = lazy(() => import("./pages/AboutMe"));
const SkillsSection = lazy(() => import("./pages/SkillsSection"));
const ExperiencePage = lazy(() => import("./pages/ExperiencePage"));
const Projects = lazy(() => import("./pages/Projects"));
const ContactModal = lazy(() => import("./components/ContactModal"));

const App = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [isContactOpen, setIsContactOpen] = useState(false);

  // Loader handles its own lifecycle via onFinish callback

  return (
    <>
      {showLoader ? (
        <Loader onFinish={() => setShowLoader(false)} />
      ) : (
        <div className="bg-[#0F0005] min-h-screen text-white selection:bg-[#ff2239] selection:text-white relative">
          <Navbar onHireMeClick={() => setIsContactOpen(true)} />
          <Suspense fallback={null}>
            {isContactOpen && (
              <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
            )}
          </Suspense>
          <main>
            <div id="home">
              <Landing />
            </div>
            <Suspense fallback={null}>
              <DeferredSection minHeight="100vh">
                <div id="about">
                  <AboutMe />
                </div>
              </DeferredSection>
              <DeferredSection minHeight="100vh">
                <div id="skills">
                  <SkillsSection />
                </div>
              </DeferredSection>
              <DeferredSection minHeight="100vh">
                <div id="experience">
                  <ExperiencePage />
                </div>
              </DeferredSection>
              <DeferredSection minHeight="100vh">
                <div id="projects">
                  <Projects />
                </div>
              </DeferredSection>
            </Suspense>
          </main>
          <div id="contact">
            <Footer />
          </div>
        </div>
      )}
      <Analytics />
    </>
  );
};

export default App;
